module.exports = __webpack_public_path__ + "img/spi.f706807f.svg";